// extracted by mini-css-extract-plugin
export var downArrow = "_bc-0";
export var infoTooltipIcon = "_bc-3";
export var label = "_bc-1";
export var optionCard = "_bc-4";
export var upArrow = "_bc-2";